import { SORT_ASC } from '@/state/types/query'

const defaultState = {
  sort: 'title',
  order: SORT_ASC,
  page: 1,
  perPage: 10,
  filter: {},
}

export default defaultState



// WEBPACK FOOTER //
// ./state/static/components.js